<template>
  <div class="mt20 item-wrapper" style="position: relative">
    <div class="delete-icon" @click.stop="deleteItem">
      <!--<a>删除</a>-->
      <!--<Icon type="ios-trash-outline" size="25"></Icon>-->
      <img :src="deleteicon" alt="" style="width: 25px">
    </div>
    <Form class="form" ref="typeItem" :rules="formRules" :model="formData" :label-width="100" :inline="true">
      <FormItem label="房型名称" prop="houseTypeName">
        <Input class="input-long" v-model="formData.houseTypeName" :disabled="disabled"/>
      </FormItem>
      <FormItem label="户型名称" prop="houseType">
        <Select class="select-width" type="number" v-model="formData.houseType" :disabled="disabled">
          <Option value="">请选择</Option>
          <Option v-for="(item,index) in houseTypeEnum" :value="item.value" :key="'housetype'+index">{{item.text}}</Option>
        </Select>
      </FormItem>
      <br>
      <FormItem label="室" prop="houseTypeRooms">
        <Select class="select-width" v-model="formData.houseTypeRooms" :disabled="disabled">
          <Option value="">请选择</Option>
          <Option v-for="(item,index) in roomList" :value="item" :key="'keyA'+index">{{item}}</Option>
        </Select>
      </FormItem>
      <FormItem label="厅" prop="houseTypeHall">
        <Select class="select-width" v-model="formData.houseTypeHall" :disabled="disabled">
          <Option value="">请选择</Option>
          <Option v-for="(item,index) in tingList" :value="item" :key="'keyB'+index">{{item}}</Option>
        </Select>
      </FormItem>
      <FormItem label="卫" prop="houseTypeBathroom">
        <Select class="select-width" v-model="formData.houseTypeBathroom" :disabled="disabled">
          <Option value="">请选择</Option>
          <Option v-for="(item,index) in weiList" :value="item" :key="'keyC'+index">{{item}}</Option>
          <!--<Option value=""></Option>-->
        </Select>
      </FormItem>
      <FormItem label="房型面积" prop="houseTypeArea">
        <Input class="input-short" v-model="formData.houseTypeArea" :disabled="disabled"/>
      </FormItem>
      <br>
      <FormItem label="房型描述" prop="houseTypeDescription">
        <Input class="textarea-width" type="textarea" v-model="formData.houseTypeDescription" :disabled="disabled"/>
      </FormItem>
      <br>
      <FormItem label="户型图" prop="houseTypeImage">
        <div class="upload-wrap">
          <img class="imgwidth" v-if="formData.houseTypeImage"  :src="formData.houseTypeImage" @click="showImg(formData.houseTypeImage)"/>
          <Upload
            :action="baseUrl+'/file/uploadFile'"
            :on-success="sethouseTypeImage"
            :headers="{'Access-Token':token}"
            :show-upload-list="false"
            :format="['jpg','jpeg','png']"
            :on-format-error="handleFormatError"
          >
            <div v-if="!formData.houseTypeImage" class="upload" :class="{error: !validatehouseTypeImage}">
              <Icon type="ios-upload-outline" color="#DDDEE1" size="40" style="vertical-align: middle"></Icon>
              <p>点击上传图片</p>
            </div>
            <a v-if="!formData.houseTypeImage && !validatehouseTypeImage" class="error-color" href="javascript:;">请上传附件</a>
            <div class="uploadEdit"><a class="uploadEditFont" v-if="formData.houseTypeImage" href="javascript:;">修改</a></div>

          </Upload>
          <a v-if="formData.houseTypeImage" @click="deleteImage()">删除</a>
        </div>
      </FormItem>
      <br>
      <FormItem label="备注" prop="remark">
        <Input class="textarea-width" v-model="formData.remark" :disabled="disabled"/>
      </FormItem>
    </Form>
  </div>

</template>

<script>
  import  deleteicon from '../../../../assets/icon/icon_delete@2x.png'
  import { getBaseUrl } from "@/utils/public";
  import { getToken } from "@/utils/auth";
  export default {
    props:{
      disabled:{
        type:Boolean,
        default:false
      },

      index:{
        type:Number,
        default:0
      },
      houseTypeEnum:{
        type:Array,
        default:()=>{return []}
      },
      formData:{
        type:Object,
        default:()=>{
          return    {
            "fid": "string",
            "houseTypeArea": 0,
            "houseTypeBathroom": 0,
            "houseTypeDescription": "string",
            "houseTypeHall": 0,
            "houseTypeName": "string",
            "houseTypeImage": "string",
            "houseType":"string",
            "houseTypeRooms": 0,
            "projectFid": "string",
            "remark": "string"
          }
        }
      }
    },
    data(){
      return {
        validatehouseTypeImage:true,
        deleteicon:deleteicon,
        roomList:[1,2,3,4,5,6,7],
        tingList:[0,1,2,3,4,5,6,7],
        weiList:[0,1,2,3,4,5,6,7],
        houseTypeList:[],
        formRules:{
          "fid": [],
          "houseTypeArea":[
            {required: true, message: ' ', trigger: 'blur', validator:this.validateNumber2}
          ],
          "houseTypeBathroom": [
            {required: true, message: ' ', trigger: 'change', validator:this.validateNumber}
          ],
          "houseTypeDescription":[
            {required: true, message: ' ', trigger: 'blur', type: 'string'}
          ],
          "houseTypeHall": [
            {required: true, message: ' ', trigger: 'change', validator:this.validateNumber}
          ],
          "houseTypeName": [
            {required: true, message: ' ', trigger: 'blur', type: 'string'}
          ],
          "houseTypeRooms": [
            {required: true, message: ' ', trigger: 'change',validator:this.validateNumber}
          ],
          // "projectFid": "string",
          "remark": [
            {required: false, message: ' ', trigger: 'blur', type: 'string'}
          ]
        },
      }
    },
    methods:{
      validateNumber(rule, value, callback) {
        let pattern = /^\d+$/
        if (!pattern.test(value)) {
          callback(new Error('请输入正确数字'));
        }
        callback();
      },
      showImg(img) {
        this.$emit('show-img',img)
      },
      deleteImage() {
        this.$Modal.confirm({
          title: '删除',
          content: '确认删除户型图片？',
          onOk: () => {
            this.formData.houseTypeImage = null;
          }
        })
      },
      handleFormatError() {
        this.$Message.error('请输入jpg,jpeg,png,格式的文件')
      },
      sethouseTypeImage(response){
        if(response.data){
          this.formData.houseTypeImage = response.data.url
          this.validatehouseTypeImage = true
        }
      },
      formValidate() {
        let obj = {}
        this.$refs[`formData${this.i}`].validate( bool => {
          if(bool){
            if(this.formData.houseTypeImage){
              obj = Object.assign({},this.formData)
              obj.factPayment  = (obj.factPayment*100).toFixed(0)
            }else{
              this.validatehouseTypeImage = false
              obj = false
            }
          }else{
            obj = false
          }
        })
        return obj
      },
      validateNumber2(rule, value, callback) {
        let pattern =/^(\d+)(\.\d+)?$/
        if (!pattern.test(value)) {
          callback(new Error('请输入正确数字'));
        }
        callback();
      },
      deleteItem(){
        this.$emit('deleteitem',this.index)
      }
    },
    created(){
      this.baseUrl = getBaseUrl()
      this.token = getToken()
    }

  }
</script>

<style scoped>
  .item-wrapper{
    /*padding-left: 20px;*/
  }
  .form{
    border: 1px solid rgb(220,220,220);
    overflow: auto;
    padding-top: 24px;
    box-sizing: border-box;
  }
  .delete-icon{
    /*float: left;*/
    /*display: inline-block;*/
    padding:3px 30px;
    font-size: 14px;
    /*border: 1px solid rgb(220,220,220);*/
    /*border-bottom: none;*/
    /*background-color: rgb(240,240,240);*/
    text-align: right;
    box-sizing: border-box;
    position: absolute;
    right: 30px;
    top: 10px;
  }
  .textarea-width{
    width: 400px;
  }
  .input-long {
    width: 200px;
  }

  .select-width {
    width: 100px;
  }

  .input-short {
    width: 100px;
  }

  .upload-wrap {
    display: inline-block;
    line-height: 1;
    padding: 10px 4px;
  }
  .imgwidth {
    width: 167px;
    height: 118px;
  }
  .upload {
    display: flex;
    flex-direction: column;
    justify-content: center;
    color: #DDDEE1;
    width: 167px;
    height: 118px;
    border: 1px dashed rgb(220, 220, 220);
    box-sizing: border-box;
    text-align: center;
  }
  .uploadEdit {
    color: #DDDEE1;
    position: absolute;
    width: 40px;
    height: 10px;
    bottom: 25px;
    top: -22px;
    left: 3px;
  }
  .uploadEditFont {
    width: 40px;
  }
  .ivu-upload {
    position: relative;
  }
  .ivu-upload  a {
    position :absolute;
    right: 0;
    bottom: -6px;
  }
  .upload.error {
    border-color:#F56356;
  }

</style>
